// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.disabled-mode[data-v-e20f436e] {\r\n    opacity: 0.5;\n}\n.tep-tarif-col-1[data-v-e20f436e] {\r\n    flex: 0 0 60%;\r\n    min-width: 800px;\n}\n.tep-tarif-col-2[data-v-e20f436e] {\r\n    flex: 0 0 40%;\r\n    min-width: 600px;\n}\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
